<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12 pt-0>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left text-uppercase">Image</th>
                <th class="text-left text-uppercase">Shop Name</th>
                <th class="text-left text-uppercase">Phone</th>
                <th class="text-left text-uppercase">Place</th>
                <th style="width: 5%" class="text-center text-uppercase">
                  Change Status
                </th>
                <th style="width: 5%" class="text-center text-uppercase">
                  Action
                </th>
                <!-- <th style="width: 5%" class="text-center text-uppercase">
                  Action
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                style="cursor: pointer; height: 90px"
                v-for="(item, i) in sellerData"
                :key="i"
                @click="$router.push('/SellerInfo?seller=' + item._id)"
              >
                <td>
                  <v-layout wrap>
                    <v-flex v-if="item.sellerid" xs12 align-self-center>
                      <v-img
                        width="80px"
                        height="85px"
                        contain
                        :src="mediaURL + item.sellerid.photo"
                      ></v-img>
                    </v-flex>
                  </v-layout>
                </td>

                <td>
                  <span v-if="item.sellerid">{{ item.sellerid.shopName }}</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <span v-if="item.phone">{{ item.phone }}</span>
                  <span v-else>-</span>
                </td>
                <td style="width: 20%">
                  <span v-if="item.sellerid">{{ item.sellerid.place }}</span>
                  <span v-else>-</span>
                </td>
                <td>{{ item.status }}</td>
                <td style="width: 15%" class="text-center">
                  <span v-if="item.status == 'Inactive'">
                    <v-btn
                      color="green"
                      @click.stop="(statusData = item), (statusDialog = true)"
                      small
                      outlined
                      ><span>Enable </span>
                    </v-btn>
                  </span>
                  <span v-else-if="item.status == 'Active'">
                    <v-btn
                      color="red"
                      @click.stop="(statusData = item), (statusDialog = true)"
                      small
                      outlined
                      ><span>Disable </span>
                    </v-btn></span
                  >
                  <span v-else>-</span>
                </td>
                <!-- <td style="width: 5%">
                  <v-btn
                    color="red"
                    small
                    outlined
                    @click.stop="(deleteData = item), (deleteDialog = true)"
                  >
                    Delete
                  </v-btn>
                </td> -->
                <!-- <td style="width: 5%">
                  <v-btn
                    color="green"
                    small
                    outlined
                    :to="'/SellerInfo?seller=' + item._id"
                  >
                    View
                  </v-btn>
                </td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="statusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title v-if="statusData.status == 'Active'"
          >Are you sure you want to disable this Seller?</v-card-title
        >
        <v-card-title v-if="statusData.status == 'Inactive'"
          >Are you sure you want to enable this Seller?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title
          >Are you sure you want to remove this seller</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["sellerData", "pages", "filter"],
  // props: ["fromDate","toDate","programme"],
  data() {
    return {
      deleteData: {},
      currentPage: 1,
      // pages: 0,
      // sellerData: [],
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      statusDialog: false,
      statusData: {},
      deleteDialog: false,
    };
  },
  // watch: {
  //   currentPage() {
  //     this.winStepper();
  //   },
  // },

  watch: {
    // fromDate() {
    // },
    // toDate() {
    // },
    // programme() {
    // },
    currentPage() {
      this.winStepper();
    },
  },
  beforeMount() {
    this.winStepper();
  },
  methods: {
    winStepper() {
      // console.log("step", this.currentPage);
      // alert("my call win comp")
      this.$emit("stepper", {
        currentPage: this.currentPage,
        pages: this.pages,
      });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    changeStatus() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/seller/status/change/" + this.statusData._id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
              currentPage: this.currentPage,
            });
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },

    deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/delete/",
        data: {
          id: this.deleteData._id,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
            });
            this.deleteDialog = false;

            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
  },
};
</script>